import React from 'react';
import {
  Grid,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Paper
} from '@mui/material';
import PropTypes from 'prop-types';

const OptOutConfig = ({ config, onChange }) => {
  const handleChange = (field, value) => {
    onChange({
      ...config,
      [field]: value
    });
  };

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="subtitle1" gutterBottom>
        Opt-Out Configuration
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={config.enable_opt_out}
                onChange={(e) => handleChange('enable_opt_out', e.target.checked)}
              />
            }
            label="Enable Opt-Out Messaging"
          />
        </Grid>
        {config.enable_opt_out && (
          <>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={2}
                label="Initial Opt-Out Notice"
                value={config.initial_opt_out_notice}
                onChange={(e) => handleChange('initial_opt_out_notice', e.target.value)}
                helperText="This message will be sent with the first message to inform participants about opt-out option"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={2}
                label="Opt-Out Confirmation Message"
                value={config.opt_out_message}
                onChange={(e) => handleChange('opt_out_message', e.target.value)}
                helperText="This message will be sent when a participant opts out"
              />
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  );
};

OptOutConfig.propTypes = {
  config: PropTypes.shape({
    enable_opt_out: PropTypes.bool,
    initial_opt_out_notice: PropTypes.string,
    opt_out_message: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default OptOutConfig; 